import dayjs from "dayjs";
import { createContext, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getLastSixMonth } from "../../../../plugins/monthList";
import { Level } from "../components/HandlingFeeStatement/components";
import { useGetAgentFeeBonus } from "../hooks/handlingfeereport.hooks";

const HandlingFeeContext = createContext({
  levels: [],
  setLevels: () => {},
  selectedMonth: null,
  setSelectedMonth: () => {},
  agentBonusId: null,
  setAgentBonusId: () => {},
  months: [],
  setMonths: () => {},
  agentFeeBonusData: undefined,
  isFeeDataLoading: true,
  isFeeDataError: false,
  levelBonusRate: [],
  setLevelBonusRate: () => {},
  totalBonus: 0,
});

export const HandlingFeeContextProvider = ({ children }) => {
  const { t } = useTranslation();
  const [levels, setLevels] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [agentBonusId, setAgentBonusId] = useState(null);
  const [months, setMonths] = useState([]);
  const [levelBonusRate, setLevelBonusRate] = useState([]);
  const [totalBonus, setTotalBonus] = useState(0);

  const {
    data: agentFeeBonusData,
    isLoading: isFeeDataLoading,
    isError: isFeeDataError,
  } = useGetAgentFeeBonus({
    params: {
      period_month: selectedMonth?.value,
    },
    options: {
      enabled: selectedMonth !== null,
    },
  });

  useEffect(() => {
    const thismonth = dayjs().month();
    const thisyear = dayjs().year();
    const lastSixMonths = getLastSixMonth(thismonth, thisyear, t);
    setMonths(lastSixMonths);
    setSelectedMonth(lastSixMonths[0]);
  }, []);

  const getLevelBonusRate = (data) => {
    const final = [];
    if (!data) return final;
    const levelGroup = Object.keys(data);
    levelGroup?.map((levelName) => {
      final.push({
        level: levelName.split("-")[1],
        bonus_rate: data[levelName]?.bonus_rate,
      });
    });
    return final;
  };

  useEffect(() => {
    if (agentFeeBonusData) {
      const _level = agentFeeBonusData.data;
      let _totalBonus = 0;
      const levelBonus = Object.keys(_level).map((key, index) => {
        const currentLevel = parseInt(key.split("-")[1]);
        _totalBonus = _totalBonus + agentFeeBonusData.data[key].level_bonus_amount;
        return {
          key: `level_bonus_${currentLevel}`,
          title: t("mobile.comission.tab.levelBonus", { level: currentLevel }),
          component: <Level level={currentLevel} />,
          destroyOnClose: true,
        };
      });
      setLevels(levelBonus);
      setTotalBonus(_totalBonus);
      const bonusRate = getLevelBonusRate(_level);
      setLevelBonusRate(bonusRate);
    }
  }, [agentFeeBonusData]);

  return (
    <HandlingFeeContext.Provider
      value={{
        levels,
        setLevels,
        selectedMonth,
        setSelectedMonth,
        agentBonusId,
        setAgentBonusId,
        months,
        setMonths,
        agentFeeBonusData,
        isFeeDataLoading,
        isFeeDataError,
        levelBonusRate,
        setLevelBonusRate,
        totalBonus,
      }}
    >
      {children}
    </HandlingFeeContext.Provider>
  );
};
export const useHandlingFee = () => {
  const WebsocketValue = useContext(HandlingFeeContext);
  return WebsocketValue;
};
